// Service worker registration and update prompt.
import { t } from '../i18n';
import { toast } from '../ui/feedback';

let reloading = false;
/** Only reload when the user accepted an update: the first install also fires controllerchange. */
let updateAccepted = false;

export function registerServiceWorker(): void {
  if (!('serviceWorker' in navigator) || !import.meta.env.PROD) return;
  window.addEventListener('load', async () => {
    try {
      const reg = await navigator.serviceWorker.register('/sw.js', { scope: '/' });
      const promptUpdate = (worker: ServiceWorker) => {
        toast(t().offline.updateReady, 'info', {
          label: t().offline.reload,
          run: () => {
            updateAccepted = true;
            worker.postMessage({ type: 'SKIP_WAITING' });
          },
        }, 0);
      };
      if (reg.waiting && navigator.serviceWorker.controller) promptUpdate(reg.waiting);
      reg.addEventListener('updatefound', () => {
        const worker = reg.installing;
        worker?.addEventListener('statechange', () => {
          if (worker.state === 'installed' && navigator.serviceWorker.controller) promptUpdate(worker);
        });
      });
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (reloading || !updateAccepted) return;
        reloading = true;
        location.reload();
      });
      // Check for updates when the tab comes back to the foreground.
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') reg.update().catch(() => undefined);
      });
    } catch {
      // Offline support unavailable (e.g. private mode); the site still works online.
    }
  });
}
